<script lang="ts">
    import {dyData} from 'general/store';
    import TrustpilotLogo from 'general/icons/TrustpilotLogo.svelte';
    import {trustpilotStore} from 'general/store/trustpilot';
    import {parseBigNumber} from 'general/libs/parseBigNumber/parseBigNumber';
    import TrustpilotExcellent from 'desktop/components/trustpilotExcellent/TrustpilotExcellent.svelte';

    import s from './style.module.css';

    export let side: 'main' | 'subscribed' | 'typ' | 'sms' = 'main';

    const tpData = $dyData.trustpilot?.[side];
    const isExcellent = $trustpilotStore.score > 4.0;
</script>

{#if tpData}
    <div style="margin-bottom: {(typeof tpData === 'object' && tpData.marginTop) || '0'}">
        {#if isExcellent}
            <div class={s.container}>
                <TrustpilotLogo />
                <img
                    src={$trustpilotStore.stars.url}
                    alt="Trustpilot rating"
                    width={98}
                    height={18}
                />

                &#x2022;

                <span>
                    {parseBigNumber($trustpilotStore.numberOfReviews)} Reviews
                </span>
            </div>
        {:else}
            <TrustpilotExcellent />
        {/if}
    </div>
{/if}
